import { useCallback, useEffect, useMemo, useState } from 'react';
import { buildPartyActivity, PARTY_ACTIVITY_METRICS } from './partyActivity.model';
import { loadPartyActivity } from './partyActivity.service';

const EMPTY_PARTIES = [];
export default function usePartyActivity(kind, parties = EMPTY_PARTIES, { enabled = true, loading = false, onMetricClick } = {}) {
  const [snapshot, setSnapshot] = useState(null);
  const [overview, setOverview] = useState('');
  const [dialogMetric, setDialogMetric] = useState('');
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision((value) => value + 1), []);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    setSnapshot(null);
    loadPartyActivity().then((result) => { if (active) setSnapshot(result); });
    return () => { active = false; };
  }, [enabled, revision]);
  useEffect(() => {
    if (!enabled) return undefined;
    const visible = () => { if (document.visibilityState !== 'hidden') refresh(); };
    window.addEventListener('focus', visible);
    window.addEventListener('webtika:deal-payments-updated', refresh);
    return () => {
      window.removeEventListener('focus', visible);
      window.removeEventListener('webtika:deal-payments-updated', refresh);
    };
  }, [enabled, refresh]);
  const activity = useMemo(() => buildPartyActivity({ kind, parties, data: snapshot?.data }), [kind, parties, snapshot]);
  const ready = (id) => enabled && !loading && snapshot?.ready[id] === true;
  const setFilter = (id) => setOverview(PARTY_ACTIVITY_METRICS.some((metric) => metric.id === id) ? id : '');
  const metrics = PARTY_ACTIVITY_METRICS.map((metric) => ({
    ...metric,
    value: ready(metric.id) ? activity[metric.id].size : '—',
    active: overview === metric.id,
    onClick: ready(metric.id) ? () => {
      onMetricClick?.();
      setOverview(metric.id);
      setDialogMetric(metric.id);
    } : undefined,
  }));
  return {
    metrics,
    overview,
    dialogMetric: PARTY_ACTIVITY_METRICS.find((metric) => metric.id === dialogMetric),
    dialogItems: ready(dialogMetric) ? parties.filter((party) => activity[dialogMetric].has(String(party.id))) : [],
    dialogReady: ready(dialogMetric),
    closeDialog: () => setDialogMetric(''),
    setFilter,
    reset: () => { setOverview(''); setDialogMetric(''); },
    filterRows: (rows = []) => !overview ? rows : !ready(overview) ? [] : rows.filter((row) => activity[overview].has(String(row.id))),
    filterGroup: {
      key: 'activity', label: 'Attività', selection: 'single', emptyValue: '',
      options: PARTY_ACTIVITY_METRICS.map((metric) => ({ value: metric.id, label: metric.label, disabled: !ready(metric.id) })),
    },
    loading: enabled && (loading || !snapshot),
    unavailable: enabled ? snapshot?.unavailable || [] : [],
  };
}
